module.exports = __webpack_public_path__ + "static/img/wxpcr.a96a382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpcr.png
// module id = uxxZ
// module chunks = 1